/* eslint-disable camelcase */
import { Box, Typography } from '@mui/material';

const columns = (RenderJsonField, renderActions, renderValueCell, renderRunReportCell, renderNotesCell, renderSubmit, renderResultCell) => [
  {
    field: 'hide',
    headerName: 'Report',
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold' }}>
        Report
      </Typography>
      </Box>
    ),
    width: 70,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderRunReportCell,
  },
  {
    field: 'name',
    headerName: 'Name',
    width: 390,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'run_details',
    headerName: 'Details',
    headerAlign: 'center',
    hide: true,
    align: 'center',
    width: 220,
    renderCell: (data) => {
      return <RenderJsonField value={data?.row ? data?.row : {}} />;
    }
  },
  {
    field: 'notes',
    headerName: 'Notes',
    width: 100,
    headerAlign: 'center',
    renderCell: renderNotesCell,
    align: 'center',
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  },
  {
    field: 'submit',
    headerName: 'Submit',
    width: 190,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderSubmit,
  },
  {
    field: 'results',
    headerName: 'Results',
    width: 280,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderResultCell,
  },
];
export default columns;
